
function HeroComponent() {
    const AutomaticScrollDelay = 7500;
    for (let heroComponent of document.querySelectorAll('.hero')) {
        let slides = heroComponent.querySelector('.slides');
        let previous = heroComponent.querySelector('.previous');
        let next = heroComponent.querySelector('.next');
        let activeSlideIndex = 0;
        let slideNavigation = heroComponent.querySelectorAll('.slide-navigation button');
        previous.addEventListener('click', function() {
            let previouslyActiveDot = slideNavigation[activeSlideIndex];
            previouslyActiveDot.classList.remove('active');
            previouslyActiveDot.classList.add('inactive');
            activeSlideIndex = (activeSlideIndex + slideNavigation.length - 1) % slideNavigation.length;
            let activeSlide = slides.children[activeSlideIndex + 1];
            slides.scrollTo({ 'left': activeSlide.offsetLeft - slides.offsetLeft, 'behavior': 'smooth' });
            let activeDot = slideNavigation[activeSlideIndex];
            activeDot.classList.remove('inactive');
            activeDot.classList.add('active');
        });
        next.addEventListener('click', function() {
            let previouslyActiveDot = slideNavigation[activeSlideIndex];
            previouslyActiveDot.classList.remove('active');
            previouslyActiveDot.classList.add('inactive');
            activeSlideIndex = (activeSlideIndex + 1) % slideNavigation.length;
            let activeSlide = slides.children[activeSlideIndex + 1];
            slides.scrollTo({ 'left': activeSlide.offsetLeft - slides.offsetLeft, 'behavior': 'smooth' });
            let activeDot = slideNavigation[activeSlideIndex];
            activeDot.classList.remove('inactive');
            activeDot.classList.add('active');
        });
        for (let index = 0; index < slideNavigation.length; index += 1) {
            let dot = slideNavigation[index];
            let slide = slides.children[index + 1];
            dot.addEventListener('click', function() {
                let previouslyActiveDot = slideNavigation[activeSlideIndex];
                previouslyActiveDot.classList.remove('active');
                previouslyActiveDot.classList.add('inactive');
                activeSlideIndex = index;
                slides.scrollTo({ 'left': slide.offsetLeft - slides.offsetLeft, 'behavior': 'smooth' });
                let activeDot = slideNavigation[activeSlideIndex];
                activeDot.classList.remove('inactive');
                activeDot.classList.add('active');
            });
            
        }
        function ScrollAutomatically() {
            let activeSlide = slides.children[activeSlideIndex + 2];
            slides.scrollTo({ 'left': activeSlide.offsetLeft, 'behavior': 'smooth' });
            scrollAutomatically = window.setTimeout(ScrollAutomatically, AutomaticScrollDelay);
        }
        let scrollAutomatically = window.setTimeout(ScrollAutomatically, AutomaticScrollDelay);
        slides.addEventListener('scroll', function() {
            window.clearTimeout(scrollAutomatically)
            scrollAutomatically = window.setTimeout(ScrollAutomatically, AutomaticScrollDelay);
            let previouslyActiveDot = slideNavigation[activeSlideIndex];
            activeSlideIndex = (Math.round(slides.scrollLeft/slides.clientWidth) + slideNavigation.length - 1) % slideNavigation.length;
            let activeDot = slideNavigation[activeSlideIndex];
            if (previouslyActiveDot !== activeDot) {
                previouslyActiveDot.classList.remove('active');
                previouslyActiveDot.classList.add('inactive');
                activeDot.classList.remove('inactive');
                activeDot.classList.add('active');
            }
            if (slides.scrollLeft + slides.clientWidth === slides.scrollWidth) {
                slides.scrollTo({ left: slides.clientWidth, behaviour: 'instant' });
            }
            else if (slides.scrollLeft === 0) {
                slides.scrollTo({ left: slides.scrollWidth - 2*slides.clientWidth, behaviour: 'instant' });
            }
        });
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', HeroComponent);
}
else {
    HeroComponent();
}
